<div class="modal-header" *ngIf="isModal">
  <h5 class="modal-title">{{'listino.editTitle' | translate}}</h5>
  <button type="button" class="close" (click)="close()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div [ngClass]="{'modal-body': isModal, 'card': !isModal}">
  <div [ngClass]="{'card-body': !isModal}">
    <div class="row" >
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">{{'prodotti.name' | translate}}</label>
          <ng-multiselect-dropdown [settings]="dropdownSettings" style="width: 80%; " [placeholder]="'prodotti.name' | translate"
                                   [data]="Prodotti" [(ngModel)]="ProdottiSelezionati"
                                   (onFilterChange)="filtroProdotti($event)"
          >
          </ng-multiselect-dropdown>
        </div>
      </div>
      <div class="col-sm-12 col-md-3">
        <div class="form-group">
          <label for="codice_produttore" class="control-label col-form-label">{{'prodotti.CodiceP' | translate}}</label>
          <input [(ngModel)]="prodotto.codice_produttore" type="text" class="form-control" id="codice_produttore" placeholder="{{'prodotti.CodiceP' | translate}}">
        </div>
      </div>
      <div class="col-sm-12 col-md-3">
        <div class="form-group">
          <label for="adhocCode" class="control-label col-form-label">{{'adhocCode' | translate}}</label>
          <input [(ngModel)]="prodotto.codiceAdhoc" type="text" class="form-control" id="adhocCode" placeholder="{{'adhocCode' | translate}}">
        </div>
      </div>
      <div class="col-sm-12 col-md-3">
        <div class="form-group">
          <label for="prezzo" class="control-label col-form-label">{{'prodotti.Price' | translate}}</label>
          <input [(ngModel)]="prodotto.prezzo" type="text" class="form-control" id="prezzo" placeholder="{{'prodotti.Price' | translate}}">
        </div>
      </div>
      <div class="col-md-12 ">
        <div class="form-group">
          <label  class="control-label col-form-label">{{'prodotti.descrizione' | translate}}</label>
          <textarea class="form-control" rows="4" [(ngModel)]="prodotto.note"></textarea>
        </div>
      </div>
      <div class="col-md-12">
        <div class="table-responsive">
          <app-listino-prodotti-aggiunte [(Aggiunte)]="prodotto.aggiunte"></app-listino-prodotti-aggiunte>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="d-md-flex align-items-center p-3" style="padding-right: 25px;">
  <button (click)="saveClick()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
    <span class="ml-1 text-white font-weight-bold"> {{'listino.salva' | translate}} </span>
  </button>
</div>
